import {KTIcon} from '../../../_metronic/helpers'
import MultimediaContentItem from './MultimediaContentItem'

function MultimediaContentModal({item = []}: any) {
  if (item.length > 0) {
    return null
  }
  return (
    <div className='modal fade' tabIndex={-1} id='multimediaContent_modal'>
      <div className='modal-dialog modal-fullscreen p-5'>
        <div className='modal-content shadow-none'>
          <div className='modal-header'>
            <h3 className='modal-title'>{item?.contentTitle}</h3>
            <div
              className='btn btn-icon btn-sm btn-active-light-primary ms-2'
              data-bs-dismiss='modal'
              aria-label='Close'
            >
              <KTIcon iconName='cross' className='fs-2qx' />
            </div>
          </div>
          <div className='modal-body d-flex justify-content-center'>
            <div className={`card card-flush w-75`}>
              <MultimediaContentItem key={item.id} item={item} index={item.id} />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default MultimediaContentModal
